import { render, staticRenderFns } from "./Materi2.vue?vue&type=template&id=bba11c8a&"
import script from "./Materi2.vue?vue&type=script&lang=js&"
export * from "./Materi2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports